import { type ConditionRuleProblem, pickT } from "@repo/shared";
import { T } from "./condition-rule-problem-message.i18n";

export function conditionRuleProblemMessage(problem: ConditionRuleProblem, lang: string): string {
  return pickT(T, lang)[problem];
}
